<!-- <div class="d-flex">
    <div class="cont">
        <div class="wrapper">
            <div class="description shine mt-4 mb-4"></div>
            <div class="description shine mt-4 mb-4"></div>
            <div class="description shine mt-4 mb-4"></div>
            <div class="description shine mt-4 mb-4"></div>
            <div class="description shine mt-4 mb-4"></div>
            <div class="description shine mt-4 mb-4"></div>
        </div>
    </div>
    <div class="cont2 ms-4">
        <div class="wrapper2">
            <div class="d-flex justify-content-between mt-2 mb-2">
                <div class="line shine"></div>
                <div class="line shine"></div>
            </div>
            <div class="d-flex mt-2 mb-2">
                <div class="line2 shine me-2"></div>
                <div class="line shine"></div>
            </div>
            <div class="box shine mt-2 mb-2"></div>
        </div>
    </div>
</div> -->

<div class="d-flex justify-content-between mt-2 mb-2">
  <div class="line shine"></div>
</div>
